<style scoped lang="less">
@import './style.less';
</style>
<script>
import methods from './methods.js'

export default {
  name: "list",
  mixins: [methods],
}
</script>
<template>
  <div class="list">
    <div class="list_head">
      <div :style="parseStyle(col.width,col.align)" class="list_head_cell"   v-for="col of columns" :key="col.key">
        {{col.label}}
      </div>
    </div>

    <div class="list_body" v-if="!isEmpty">
      <div class="list_body_row" v-for="row of listData" :key="row.name">
        <div :style="parseStyle(col.width,col.align)" class="list_body_row_cell" v-for="col of columns" :key="col.key">
          {{ row[col.key].replace("粉丝", "") }}
        </div>
      </div>
    </div>
    <none-data :height="3.5" v-else></none-data>
  </div>
</template>

